export default __webpack_public_path__ + "static/media/step-2.7a748ed7.png";